var _rect, _line, _path, _path2, _path3, _path4, _path5, _line2, _line3, _line4, _line5, _line6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperShredder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 23,
    height: 16,
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 26,
    x2: 21,
    y2: 26,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 16C5.00001 16.5523 4.55229 17 4.00001 17C3.44772 17 3.00001 16.5523 3.00001 16C3.00001 15.4477 3.44772 15 4.00001 15C4.55229 15 5.00001 15.4477 5.00001 16Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 16C8.00001 16.5523 7.55229 17 7.00001 17C6.44772 17 6.00001 16.5523 6.00001 16C6.00001 15.4477 6.44772 15 7.00001 15C7.55229 15 8.00001 15.4477 8.00001 16Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9.00001 16.5523 9.00001 16C9.00001 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16Z",
    fill: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1992 15.6001H20.7992",
    stroke: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2C3.5 1.17157 4.17157 0.5 5 0.5H19C19.8284 0.5 20.5 1.17157 20.5 2V12.5H3.5V2Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.27344,
    y1: 3.04541,
    x2: 11.1825,
    y2: 3.04541,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.27344,
    y1: 5.40918,
    x2: 16.0916,
    y2: 5.40918,
    stroke: "#A3A3A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.27344,
    y1: 7.77246,
    x2: 16.0916,
    y2: 7.77246,
    stroke: "#A3A3A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.27344,
    y1: 10.1362,
    x2: 11.1825,
    y2: 10.1362,
    stroke: "#A3A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8184,
    y1: 10.1362,
    x2: 14.4547,
    y2: 10.1362,
    stroke: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 25.25,
    width: 1.49998,
    height: 7.04311,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 25.25,
    width: 1.49998,
    height: 7.04311,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 25.25,
    width: 1.49998,
    height: 8.30029,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 25.25,
    width: 1.49998,
    height: 8.30029,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 25.25,
    width: 1.49998,
    height: 8.30029,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 25.25,
    width: 1.49998,
    height: 8.30029,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 25.25,
    width: 1.49998,
    height: 4.52874,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 25.25,
    width: 1.49998,
    height: 4.52874,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 25.25,
    width: 1.49998,
    height: 4.52874,
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperShredder);
export default __webpack_public_path__ + "static/media/paper-shredder.d51d7988d30e6f8a2eeeba14b215dfb0.svg";
export { ForwardRef as ReactComponent };